import { Actor, Canvas, Random } from 'excalibur';
import { getTheme } from '../themes/theme';
import { SEEDS } from '../utils/constants';
import { css, sketchStroke, wobblyArcPath, wobblyLinePath } from '../utils/sketch';

export class VideoIcon extends Actor {
  private readonly iconCanvas: Canvas;

  constructor(options: { name: string }) {
    const canvas = new Canvas({
      width: 76,
      height: 60,
      cache: true,
      draw: (ctx) => paintVideoIcon(ctx),
    });
    super({ name: options.name, graphic: canvas });
    this.iconCanvas = canvas;
  }

  refreshTheme(): void {
    this.iconCanvas.flagDirty();
  }
}

function paintVideoIcon(ctx: CanvasRenderingContext2D): void {
  const rng = new Random(SEEDS.videoIcon);
  const palette = getTheme().palette;
  const width = 60;
  const height = 46;
  const x = (76 - width) / 2;
  const y = (60 - height) / 2;
  const radius = 12;

  ctx.save();
  ctx.fillStyle = css(palette.paper, 0.95);
  ctx.beginPath();
  if (typeof ctx.roundRect === 'function') {
    ctx.roundRect(x + 3, y + 3, width - 6, height - 6, radius);
  } else {
    ctx.rect(x + 3, y + 3, width - 6, height - 6);
  }
  ctx.fill();
  ctx.restore();

  const edges: Array<(c: CanvasRenderingContext2D) => void> = [
    (c) => wobblyLinePath(c, x + radius, y, x + width - radius, y, rng, 1.2, 6),
    (c) => wobblyLinePath(c, x + width, y + radius, x + width, y + height - radius, rng, 1.2, 5),
    (c) => wobblyLinePath(c, x + width - radius, y + height, x + radius, y + height, rng, 1.2, 6),
    (c) => wobblyLinePath(c, x, y + height - radius, x, y + radius, rng, 1.2, 5),
    (c) => wobblyArcPath(c, x + width - radius, y + radius, radius, -Math.PI / 2, 0, rng, 1, 6),
    (c) => wobblyArcPath(c, x + width - radius, y + height - radius, radius, 0, Math.PI / 2, rng, 1, 6),
    (c) => wobblyArcPath(c, x + radius, y + height - radius, radius, Math.PI / 2, Math.PI, rng, 1, 6),
    (c) => wobblyArcPath(c, x + radius, y + radius, radius, Math.PI, Math.PI * 1.5, rng, 1, 6),
  ];
  for (const edge of edges) {
    sketchStroke(ctx, rng, { color: palette.ink, width: 2.6, alpha: 0.85 }, edge, 2, 1.2);
  }

  const centerX = 38;
  const centerY = 30;
  ctx.save();
  ctx.fillStyle = css(palette.pinkDeep, 0.95);
  ctx.beginPath();
  ctx.moveTo(centerX - 8 + rng.floating(-1, 1), centerY - 11 + rng.floating(-1, 1));
  ctx.lineTo(centerX - 8 + rng.floating(-1, 1), centerY + 11 + rng.floating(-1, 1));
  ctx.lineTo(centerX + 11 + rng.floating(-1, 1), centerY + rng.floating(-1, 1));
  ctx.closePath();
  ctx.fill();
  ctx.restore();
}
